module.exports = __webpack_public_path__ + "img/INTERIOR-SWIFT-2021-3.e69dbf39.jpg";